export default class Menu {

    constructor() {
        this.mobile();
        this.links();
        this.subMenu();
    }

    mobile() {
        var menuContainer = document.querySelector(".site-header__middle")
        var btnMenu = document.querySelector(".menu-btn__toggle")

        btnMenu.addEventListener('click', function () {
            const isActive = menuContainer.classList.toggle('active');
            document.body.style.overflow = isActive ? 'hidden' : '';
        })
    }

    links() {
        var links = document.querySelectorAll(".primary-menu .menu .level-0")

        for (var i = 0; i < links.length; i++) {
            var link = links[i];

            link.classList.remove('active')

            link.addEventListener('click', function (e) {
                this.classList.toggle('active')
            })

        }
    }

    subMenu() {
        var subMenu = document.querySelectorAll(".primary-menu .menu .menu-item-has-children.level-1")

        for (var i = 0; i < subMenu.length; i++) {
            var e = subMenu[i];
            e.parentElement.parentElement.parentElement.classList.add('top-multi-level')
            e.parentElement.parentElement.classList.add('multi-level')
        }
    }
}
